import { render, staticRenderFns } from "./CohortTabs.vue?vue&type=template&id=d7a4b8c4"
import script from "./CohortTabs.vue?vue&type=script&lang=js"
export * from "./CohortTabs.vue?vue&type=script&lang=js"
import style0 from "./CohortTabs.vue?vue&type=style&index=0&id=d7a4b8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports